
import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-12 sm:pt-16 lg:pt-20 pb-6 sm:pb-8 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-48 sm:w-96 h-48 sm:h-96 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-48 sm:w-96 h-48 sm:h-96 bg-red-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-12 sm:mb-16 pb-12 sm:pb-16 border-b border-gray-800">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-red-500 to-blue-600 bg-clip-text text-transparent mb-4 sm:mb-5" style={{ fontFamily: '"Pacifico", serif' }}>
              Madina Associates
            </h3>
            <p className="text-gray-400 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base">
              Building dreams and creating value through exceptional property dealing and construction services for over 15 years.
            </p>
            <div className="flex gap-2 sm:gap-3">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-gray-800 rounded-xl hover:bg-gradient-to-br hover:from-red-500 hover:to-blue-600 text-gray-400 hover:text-white transition-all hover:scale-110 cursor-pointer border border-gray-700 hover:border-transparent">
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-gray-800 rounded-xl hover:bg-gradient-to-br hover:from-red-500 hover:to-blue-600 text-gray-400 hover:text-white transition-all hover:scale-110 cursor-pointer border border-gray-700 hover:border-transparent">
                <i className="ri-twitter-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-gray-800 rounded-xl hover:bg-gradient-to-br hover:from-red-500 hover:to-blue-600 text-gray-400 hover:text-white transition-all hover:scale-110 cursor-pointer border border-gray-700 hover:border-transparent">
                <i className="ri-linkedin-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 sm:w-11 h-10 sm:h-11 flex items-center justify-center bg-gray-800 rounded-xl hover:bg-gradient-to-br hover:from-red-500 hover:to-blue-600 text-gray-400 hover:text-white transition-all hover:scale-110 cursor-pointer border border-gray-700 hover:border-transparent">
                <i className="ri-instagram-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 group text-sm sm:text-base">
                  <i className="ri-arrow-right-s-line text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 group text-sm sm:text-base">
                  <i className="ri-arrow-right-s-line text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('properties')} className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 group text-sm sm:text-base">
                  <i className="ri-arrow-right-s-line text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Properties
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 group text-sm sm:text-base">
                  <i className="ri-arrow-right-s-line text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Projects
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 group text-sm sm:text-base">
                  <i className="ri-arrow-right-s-line text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-white">Our Services</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="text-gray-400 flex items-center gap-2 text-sm sm:text-base">
                <i className="ri-check-line text-blue-500 text-sm flex-shrink-0"></i>
                Property Dealing
              </li>
              <li className="text-gray-400 flex items-center gap-2 text-sm sm:text-base">
                <i className="ri-check-line text-blue-500 text-sm flex-shrink-0"></i>
                Construction Services
              </li>
              <li className="text-gray-400 flex items-center gap-2 text-sm sm:text-base">
                <i className="ri-check-line text-blue-500 text-sm flex-shrink-0"></i>
                Land Development
              </li>
              <li className="text-gray-400 flex items-center gap-2 text-sm sm:text-base">
                <i className="ri-check-line text-blue-500 text-sm flex-shrink-0"></i>
                Investment Consulting
              </li>
              <li className="text-gray-400 flex items-center gap-2 text-sm sm:text-base">
                <i className="ri-check-line text-blue-500 text-sm flex-shrink-0"></i>
                Legal Support
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-white">Contact Info</h4>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start gap-3 text-gray-400 group cursor-pointer">
                <i className="ri-map-pin-line mt-1 flex-shrink-0 text-blue-500 group-hover:scale-110 transition-transform text-sm sm:text-base"></i>
                <span className="leading-relaxed group-hover:text-gray-300 transition-colors text-sm sm:text-base">123 Business Avenue, Suite 500, Metropolitan City, MC 12345</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 group cursor-pointer">
                <i className="ri-phone-line flex-shrink-0 text-blue-500 group-hover:scale-110 transition-transform text-sm sm:text-base"></i>
                <span className="group-hover:text-gray-300 transition-colors text-sm sm:text-base">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 group cursor-pointer">
                <i className="ri-mail-line flex-shrink-0 text-blue-500 group-hover:scale-110 transition-transform text-sm sm:text-base mt-1"></i>
                <span className="group-hover:text-gray-300 transition-colors text-sm sm:text-base break-all">info@madinaassociates.com</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 group cursor-pointer">
                <i className="ri-time-line flex-shrink-0 text-blue-500 group-hover:scale-110 transition-transform text-sm sm:text-base"></i>
                <span className="group-hover:text-gray-300 transition-colors text-sm sm:text-base">Mon - Sat: 9:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
          <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © 2024 Madina Associates. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-8 text-xs sm:text-sm flex-wrap justify-center sm:justify-end">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap">
              Terms of Service
            </Link>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap">
              <i className="ri-sparkling-line"></i>
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
